module.exports = __webpack_public_path__ + "img/logo_210.109d7a05.svg";